import React from "react";
import "video.js";

export function VideoModule(props) {
  const { clientKey, settings, loop, hideControl } = props;
  const { url, downloadable } = settings;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        backgroundColor: "#000",
      }}
    >
      <video
        id={"jirango-vod-" + clientKey}
        className="video-js"
        controls={!hideControl}
        autoPlay={loop}
        loop={loop}
        preload="auto"
        style={{ width: "100%", height: "100%" }}
        poster="MY_VIDEO_POSTER.jpg"
        controlsList="nodownload"
        data-setup="{}"
      >
        <source src={url} type="video/mp4" />
        <source src={url} type="video/webm" />
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
          </a>
        </p>
      </video>
    </div>
  );
}
